import Vue from "vue";

Vue.component("notifications-languages", {
	props: ["notificationId"],
	data() {
		return {
			languages: [],
			dolLink: "",
			loading: true
		};
	},
	computed: {
		loadingText() {
			return window.labels.loading + "..";
		}
	},
	methods: {
		downloadLink: function (language, docs) {
			var url = window.urls.wtoDocsLink;
			docs = docs.replace(/\\/g, "/");
			switch (language) {
			case "En":
				url += `t/${docs}`;
				break;
			case "Fr":
				url += `u/${docs}`;
				break;
			case "Es":
				url += `v/${docs}`;
				break;
			}
			return url;
		},
		getNotificationLanguages: function() {
			this.loading = true;
			this.$services.notifications.getNotificationLanguages({
					id: this.notificationId
				})
				.then((data) => {
					this.loading = false;
					this.languages = data.languages;
					this.dolLink = data.dolLink;
				});
		}
	},
	mounted() {
		this.getNotificationLanguages();
	},
	template: `
		<div>
      		<div v-if="loading">
		        <loading :loading-text="loadingText"></loading>
      		</div>
      		<div v-else>
			    <div v-if="dolLink">
					<a v-for="item in languages" :href="downloadLink(item, dolLink)" target="_blank">{{item}}&nbsp</a>
				</div>
			</div>
		</div>
	`
});